import React from 'react';

export function AuthenticationComplete() {
  return (
    <div className="hero is-fullheight">
      <div className="hero-body is-paddingless">
        <div className="container has-text-centered">
          <div className="column is-4 is-offset-4">
            <div className="box p-6">
              <a href="/">
                <img src="/images/logo.png" alt="logo" />
              </a>
              <h5 className='mt-2'>You will shortly be redirected to ChatCLB</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
